import style from './style.module.css';

const PlayerSubtitles = ({ currentTime, cues }) => {
  const text = cues.find((cue) => cue.timeStart <= currentTime && cue.timeEnd >= currentTime)?.text;

  return <div className={style.subtitleContainer}>{text && <div className={style.subtitle}>{text}</div>}</div>;
};

export default PlayerSubtitles;
